/**
 * Centralized toast messages for RANERZZZ
 * All UI copy in Spanish (Argentina / Rioplatense)
 * Brand voice: Cercano, simple, marplatense.
 */

export const TOASTS = {
  success: {
    activity_posted: "Kilómetros sumados.",
    first_activity: "Primer rayo activado 🔥",
    registered: "¡Vamos! Nos vemos ahí.",
    order_confirmed: "RAAAANERRRZZZZ — Estás adentro.",
    video_uploaded: "Video enviado. Ya te damos la devolución.",
    profile_updated: "Perfil actualizado",
    logged_out: "¡Nos vemos en la próxima!",
    unregistered: "Te diste de baja. La próxima va.",
    added_to_cart: "Sumado al carrito ⚡️",
    event_reserved: "Lugar reservado. Nos vemos ahí.",
    product_added: "Sumado al merch ⚡️",
    payment_approved: "RAAAANERRRZZZZ — Nos vemos ahí.",
    stretching_completed: "Piernas vivas. ⚡️",
    points_earned: "🏅 Puntos sumados",
    reward_redeemed: "Listo Ranerzzz 🏅 Te lo validamos por WhatsApp.",
  },
  error: {
    generic: "Ups, algo se rompió.",
    not_logged_in: "Primero tenés que sumarte al grupo",
    no_stock: "No hay más stock disponible",
    premium_only: "Esta función es solo para Ranerzzz Premium",
    register_failed: "No pudimos anotarte. Intentá de nuevo.",
    upload_failed: "Error al subir el archivo",
    session_error: "Error al cerrar sesión",
    event_full: "El evento se llenó justo ahora",
  },
  info: {
    coming_soon: "Próximamente",
    payment_coming: "Próximamente: integración con Mercado Pago",
    video_player_coming: "Próximamente: reproductor de video",
    demo_mode: "Modo demo activo",
    payment_pending: "Pago pendiente. Te avisamos cuando se confirme.",
  },
} as const;

// Helper function to get toast messages
export const getToast = (
  type: keyof typeof TOASTS,
  key: string
): string => {
  const messages = TOASTS[type] as Record<string, string>;
  return messages[key] || TOASTS.error.generic;
};
